// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2m8H1","title":"ClientInsurance_title__1rtGS","itemText":"ClientInsurance_itemText__3Vd8K"};